import _ from "lodash";
import { pagesById } from "./api";
import { observable, makeObservable } from "mobx";

class SocialPagesStore {
  cachedListings = new Map();

  pendingItems = new Set();
  inflightItems = new Set();

  pages = {};

  constructor() {
    makeObservable(this, {
      cachedListings: observable,
      pages: observable
    });
  }

  page(provider, pageId) {
    // add to the list o things
    const key = cacheKey(provider, pageId);
    if (!this.cachedListings[key]) {
      if (!this.inflightItems.has(key) && !this.pendingItems.has(key)) {
        this.pendingItems.add(key);
        setTimeout(() => this.fetchPending(), 0);
      }
    }
    return this.cachedListings.get(key);
  }

  fetchPending() {
    if (this.pendingItems.size === 0) {
      return;
    }
    const requests = Array.from(this.pendingItems).map((item) => {
      this.inflightItems.add(item);
      const provider = item.substr(0, item.indexOf("-"));
      const pageId = item.substr(item.indexOf("-") + 1); // Google pageIds can be `Google-xyz-1233321adb so we can't just do a .split
      return { provider, pageId };
    });
    this.pendingItems.clear();

    const requestsByProvider = _.groupBy(requests, "provider");
    _.forOwn(requestsByProvider, (requests, provider) => {
      // Max characters allowed in URI is 2,048. Google remoteIds are ~30 characters long. 2,048 / 30 = ~68 remote Id chunks - ~100 characters for the rest = 60
      // This was previously fine at 100 for Facebook and other providers, but broke when we added Google.
      _.chunk(requests, 60).map((theRequests) => {
        pagesById(
          provider,
          theRequests.map((r) => r.pageId)
        ).then((pages) => {
          pages.forEach((page) => {
            const remoteId = page.remoteIds[0];
            this.cachedListings.set(cacheKey(provider, remoteId), page);
          });
        });
      });
    });
  }
}

function cacheKey(provider, pageId) {
  return `${provider}-${pageId}`;
}

export default new SocialPagesStore();
